export default __webpack_public_path__ + "static/media/home_screen_background.ceec9cdc.png";